import API from "../../services/API";
import axios from "axios";
import Endpoints from "../config/Endpoints";

export default {

    Submit: function (option, pageType) {
        let url = API.url(Endpoints.HealthcareOverride.Submit, {
            'pageType': pageType
        });
        return axios.post(url, {option: option})
            .then((res) => {
                console.log(res.data.data);
                return res.data.data;
            });
    }

}
